export const getFallbackBackView = (setupDetails) => {
  const cust = setupDetails?.widgetCustomizations;
  const isLegacy = setupDetails?.widgetWorkflow?.workflowId === 'legacy';
  const defaultMessageView = isLegacy ? "DexyAI" : "DexyAI";
  const defaultMessageIcon = isLegacy ? "messages" : "ai";

  // 1. Check if Home (LandingWindow) is enabled (default is true unless explicitly false)
  if (cust?.home !== false) {
    return { view: "LandingWindow", icon: "home" };
  }

  // 2. If Home is disabled, fallback to Messages (DexyAI or AutomatedBot) if enabled
  if (cust?.aiBot !== false || cust?.conversation !== false) {
    return { view: defaultMessageView, icon: defaultMessageIcon };
  }

  // 3. Fallback to Tickets (chatList) if enabled
  if (cust?.ticket !== false) {
    return { view: "chatList", icon: "tickets" };
  }

  // 4. Fallback to Help if enabled
  if (cust?.help) {
    return { view: "Help", icon: "help" };
  }

  // 5. Fallback to News if enabled
  if (cust?.news) {
    return { view: "News", icon: "news" };
  }

  // 6. Fallback to Roadmap if enabled
  if (cust?.roadmap) {
    return { view: "Roadmap", icon: "roadmap" };
  }

  // Default fallback
  return { view: defaultMessageView, icon: defaultMessageIcon };
};
